import React from 'react'

export default function LabTest() {
  return (
    <div>LabTest</div>
  )
}
